import { Cog, Mail, Phone, MapPin, Github, Linkedin, Twitter } from "lucide-react";

export function LandingFooter() {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-gradient-primary rounded-lg p-2">
                <Cog className="h-6 w-6 text-primary-foreground" />
              </div>
              <div>
                <div className="text-lg font-bold text-foreground tracking-wide">ROBOTIC IMAGING</div>
                <div className="text-xs text-primary font-medium">ASSET MANAGEMENT</div>
              </div>
            </div>
            <p className="text-muted-foreground mb-6 max-w-md">
              Revolutionary AI-powered platform transforming facility management through 
              robotic imaging, predictive analytics, and automated workflows for engineering excellence.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="h-4 w-4 text-primary" />
                <span>engineering@roboticimaging.com</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Phone className="h-4 w-4 text-primary" />
                <span>+1 (555) 789-0123</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <MapPin className="h-4 w-4 text-primary" />
                <span>Boston, MA • Silicon Valley, CA</span>
              </div>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Asset Intelligence</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Predictive Analytics</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Workflow Automation</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Mobile Inspection</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">API Integration</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Technical Demo</a></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">About Us</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Engineering Blog</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Case Studies</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Careers</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Partners</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors">Support Center</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row gap-6 text-sm text-muted-foreground">
              <span>© 2024 Robotic Imaging Asset Management. All rights reserved.</span>
              <div className="flex gap-6">
                <a href="#" className="hover:text-primary transition-colors">Privacy Policy</a>
                <a href="#" className="hover:text-primary transition-colors">Terms of Service</a>
                <a href="#" className="hover:text-primary transition-colors">Security</a>
              </div>
            </div>
            
            <div className="flex gap-4 mt-4 md:mt-0">
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}